import React, { useEffect, useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import practiceEhrImg from "../../Images/practiceehr-logo copy.png";
import Password from "./Password";
import Preference from "./Preference";
import Schedule from "./Schedule";
import {
  setHeaderRerender,
  setQuickData,
  setQuickSearch,
} from "../../store/reducers/SharedLayoutDataSlice";
import { clearTicketTaskFilters, setCurrentPage } from "../../store/reducers/TicketTaskFilter";

let headerSearch = false;

const Header = (props) => {
  const dispatch = useDispatch();
  const [popupPlan, setPopupPlan] = useState(false);
  const [Trigger, setTrigger] = useState({
    user: false,
    password: false,
    preference: false,
  });
  const [TicketSearch, setTicketSearch] = useState("");
  const ref = useRef(null);
  const searchValue = useRef();
  const { onClickOutside } = props;
  const isTrainer =
    sessionStorage.length > 0 && sessionStorage.isTrainer !== ""
      ? sessionStorage.isTrainer.toUpperCase()
      : "";

  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.name != null && event.target.name === "quickSearch") {
        headerSearch = true;
        dispatch(setQuickSearch(true));
      } else if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
        setTrigger((triggerInfo) => ({
          ...triggerInfo,
          user: false,
        }));
      }
    };

    const keyDownHandler = (event) => {
      if (
        event.key === "Enter" &&
        searchValue.current.value !== "" &&
        headerSearch === true
      ) {
        SearchTickets();
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("keydown", keyDownHandler, true);
    return () => {
      document.removeEventListener("keydown", keyDownHandler, true);
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  // const showClicked = () => {
  //   common.headerSearch = true;
  // };

  const TriggerUser = () => {
    setTrigger((triggerInfo) => ({
      ...triggerInfo,
      user: !Trigger.user,
    }));
  };

  const HandleSetPassword = (childData) => {
    setTrigger((triggerInfo) => ({
      ...triggerInfo,
      password: childData,
    }));
  };

  const HandleSetPrefernce = (childData) => {
    setTrigger((triggerInfo) => ({
      ...triggerInfo,
      preference: childData,
    }));
  };

  const ShowUserInfo = (type) => {
    if (type === "password") {
      setTrigger((triggerInfo) => ({
        ...triggerInfo,
        password: true,
        preference: false,
      }));
    } else if (type === "preference") {
      setTrigger((triggerInfo) => ({
        ...triggerInfo,
        password: false,
        preference: true,
      }));
    } else if (type === "logout") {
      sessionStorage.clear();
      clearTicketTaskFilters();
      navigate("/login");
    }
  };

  const SearchTickets = () => {
    if (headerSearch) {
      if (TicketSearch.length > 1 || searchValue.current.value.length > 0) {
        dispatch(setHeaderRerender(Date.now()));
        dispatch(setCurrentPage(1));
        navigate("/tickets");
      }
    }
  };

  const AlterTicketSearch = (e) => {
    if (e.target.value.length > 0) {
      dispatch(setQuickSearch(true));
    }
    dispatch(setQuickData(e.target.value?.trim()));
    setTicketSearch(e.target.value);
  };

  return (
    <>
      {popupPlan && <Schedule changeLoad={(newVal) => setPopupPlan(newVal)} />}

      {Trigger.password && <Password parentCallback={HandleSetPassword} />}

      {Trigger.preference && <Preference parentCallback={HandleSetPrefernce} />}

      <nav className="navbar-default container-fluid">
        <div className="row flex-center">
          <div className="col-md-8 col-sm-12">
            <div className="navbar-header fixed-brand flex-center">
              <a className="navbar-brand">
                <img src={practiceEhrImg} className="h-auto w-75" alt="" />
              </a>
            </div>
          </div>
          <div className="col-md-4 col-sm-12">
            <div className="InputTable search-box-postion">
              {isTrainer === "Y" && (
                <div className="search-box-btn">
                  <input
                    type="button"
                    value="Schedule Meeting"
                    className="btnLinkGreen"
                    onClick={() => setPopupPlan(true)}
                  />
                </div>
              )}

              {sessionStorage.type !== "SP" && sessionStorage.type !== "SA" && (
                <div className="search-box">
                  <input
                    className="search-input"
                    ref={searchValue}
                    placeholder="Quick Search"
                    name="quickSearch"
                    value={TicketSearch}
                    type="search" // onClick={(e) => showClicked(e)}
                    onChange={(e) => AlterTicketSearch(e)}
                  />
                  <button
                    className="bg-info bg-opacity-50 border-0 h-100 rounded-0 text-white w-auto"
                    onClick={() => SearchTickets()}
                  >
                    <FontAwesomeIcon icon="search" size="xs" />
                  </button>
                </div>
              )}
            </div>
            <div className="top-menu">
              <ul className="user-menu" ref={ref}>
                <li className="dropdown open">
                  <span
                    className="cursor-pointer dropdown-toggle pointer-event"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => TriggerUser()}
                  >
                    {sessionStorage.length > 0 &&
                      sessionStorage.firstName !== "" &&
                      sessionStorage.firstName.split("")[0]}
                  </span>
                  <ul
                    className={`dropdown-menu ${Trigger.user ? "d-block" : "d-none"
                      }`}
                  >
                    <li>
                      <span className="dropdownHeading">
                        {sessionStorage.length > 0 &&
                          sessionStorage.firstName !== "" &&
                          sessionStorage.firstName}{" "}
                        {sessionStorage.length > 0 &&
                          sessionStorage.lastName != "" &&
                          sessionStorage.lastName}
                        <p className="dropdownEmail">
                          {" "}
                          {sessionStorage.length > 0 &&
                            sessionStorage.USER !== "" &&
                            sessionStorage.USER}
                        </p>
                      </span>
                    </li>
                    <li onClick={() => ShowUserInfo("password")}>
                      <a role="button">Change Password</a>
                    </li>
                    <li onClick={() => ShowUserInfo("preference")}>
                      <a role="button">User Preference</a>
                    </li>
                    <li onClick={() => ShowUserInfo("logout")}>
                      <a role="button">Sign Out</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
